import { Theme } from '@mui/material'

const useStyles = {
  removeSectionBtn: (theme: Theme) => ({
    marginLeft: theme.spacing(),
  }),
  headerGrid: (theme: Theme) => ({
    marginTop: theme.spacing(),
    marginBottom: theme.spacing(-1),
  }),
}
export default useStyles
